/**
 * Currently defined types in PeacockStreamingFormat (PSF).
 */ export var PSF_MIME_TYPE = 'application/json+dash+psf';

//# sourceMappingURL=types.js.map